import {
  TextToImageConfig,
  TextUtilsService
} from "../../../textUtils.service";

// import { TextUtilsService, TextToImageConfig } from '../../textUtils.service';

declare let THREE: any;

export class LabelDim extends (THREE.Mesh as {
  new (geometry, material): any;
}) {
  private static rotationTransform = new THREE.Matrix4().makeRotationX(
    THREE.Math.degToRad(-90)
  );
  static readonly Name = "LabelDim";
  protected textConfig: TextToImageConfig;
  private width;
  private height;
  public scaleCor; 
  constructor(
    size: { width: number; height: number },
    textConfig?: TextToImageConfig
  ) {
    var heartShape = new THREE.Shape();

    heartShape.ellipse(0, 0, 1 / 2, 1 / 2, 0, 0, 2 * Math.PI);

    var geometry = new THREE.ShapeGeometry(heartShape);
    var material = new THREE.MeshBasicMaterial({ color: "#ffffff" });

    super(geometry, material);
    this.name = LabelDim.Name;
    this.textConfig = textConfig;
    this.width = size.width;
    this.height = size.height;
    this.scaleCor = 1;
    this.scale.set(size.width + 5, size.height + 5, 1);
    this.rotation.x = -Math.PI / 2;
  }

  onBeforeRender(renderer, scene, camera) {
    const scale = camera.scale.x;

    this.scale.set(this.width * this.scaleCor, this.height * this.scaleCor, 1);
  }

  updateText(text: string) {
    //     const image = TextUtilsService.textToImage(text, this.textConfig, true);
    //     if (!this.material.map) {
    //       this.material.map = new THREE.Texture(image);
    //     } else {
    //       this.material.map.image = image;
    //     }
    //     this.material.map.needsUpdate = true;
    //     this.material.needsUpdate = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Dimensions/LabelDim.ts